const emptyData = {
  RoleName: '',
  RoleLevel: 0,
  RoleLabel: '',
  PermissionName: ''
}

const validationRules = {
  RoleName: [
    {
      required: true,
      trigger: 'blur'
    }
  ],
  RoleLevel: [
    {
      required: true,
      trigger: 'blur'
    }
  ],
  RoleLabel: [
    {
      required: true,
      trigger: 'blur'
    }
  ],
  PermissionName: []
  // Permissions: [{
  // 	required: true,
  // 	trigger: 'change'
  // }],
}

export default {
  getEmptyData() {
    return emptyData
  },
  getValidationRule() {
    return validationRules
  }
}
